export const VEHICLE_COLORS: string[] = [
  '#1E88E5', // Blue
  '#FB8C00', // Orange
  '#8E24AA', // Purple
  '#00897B', // Teal
  '#FFB300', // Amber
  '#D81B60', // Pink
  '#3949AB', // Indigo
  '#6D4C41', // Brown

  '#00ACC1', // Cyan
  '#C0CA33', // Lime
  '#F4511E', // Deep Orange
  '#7E57C2', // Violet
  '#827717', // Olive
  '#FF7043', // Coral
  '#26A69A', // Turquoise
  '#C9A227', // Gold
  '#AD1457', // Magenta
  '#283593', // Navy

  '#039BE5', // Sky Blue
  '#D4A017', // Mustard
  '#455A64', // Slate
  '#66BB6A', // Mint
  '#FF8A65', // Peach
  '#9575CD', // Lavender
  '#4682B4', // Steel Blue
  '#5D4037', // Chocolate

  '#4169E1', // Royal Blue
  '#C62828', // Crimson
  '#6A1B9A', // Plum
  '#F4A460', // Sand
  '#B87333', // Copper
  '#009688', // Jade
  '#0F52BA', // Sapphire
  '#37474F', // Charcoal
  '#C2185B', // Raspberry

  '#2ECC71', // Emerald
  '#800000', // Maroon
  '#007FFF', // Electric Blue
  '#FF4500', // Sunset Orange
  '#FF1493', // Deep Pink
  '#8A9A5B', // Moss
  '#99FFFF', // Ice Blue
  '#CD7F32', // Bronze
  '#DA70D6', // Orchid
  '#722F37', // Wine

  '#00FFFF', // Aqua
  '#CCCCFF', // Periwinkle
  '#B7410E', // Rust
  '#1560BD', // Denim
  '#FFC30B', // Honey
  '#01796F', // Pine
  '#E0115F', // Ruby
  '#2F4F4F', // Graphite
  '#F28500', // Tangerine
  '#82EEFD',  // Arctic Blue

  '#1A237E', // Dark Indigo
  '#0D47A1', // Deep Blue
  '#1976D2', // Strong Blue
  '#42A5F5', // Soft Blue
  '#90CAF9', // Light Blue
  '#3F51B5', // Indigo Blue
  '#5C6BC0', // Muted Indigo
  '#7986CB', // Dusty Indigo
  '#303F9F', // Night Blue
  '#283593', // Rich Indigo

  '#4A148C', // Deep Purple
  '#6A1B9A', // Royal Purple
  '#8E24AA', // Orchid Purple
  '#9C27B0', // Vibrant Purple
  '#BA68C8', // Soft Violet
  '#CE93D8', // Pale Violet
  '#512DA8', // Strong Indigo Violet
  '#9575CD', // Lavender Indigo
  '#7B1FA2', // Plum Purple
  '#4527A0', // Dark Violet

  '#212121', // Near Black
  '#424242', // Dark Grey
  '#616161', // Neutral Grey
  '#757575', // Mid Grey
  '#9E9E9E', // Soft Grey

  '#3E2723', // Dark Brown
  '#4E342E', // Cocoa Brown
  '#6D4C41', // Earth Brown
  '#8D6E63', // Taupe Brown
  '#A1887F'  // Stone Brown
];